import { createFocusTrap } from '@root/node_modules/focus-trap';

function toggleMobileNav() {
  document.querySelector('.global-wrapper').classList.toggle('nav-open');
}

function initMobileMenuListeners() {
  var mobileOpen = document.getElementById('mobile-menu-open');

  var mobileClose = document.getElementById('mobile-menu-close');

  var containerOne = document.getElementById('overlay-menu-container');

  var focusTrapOne = createFocusTrap('#overlay-menu-container', {
    // returnFocusOnDeactivate: false,
    onDeactivate: function() {
      containerOne.classList.remove = 'is-active';
    },
  });

  mobileOpen.addEventListener('click', () => {
    toggleMobileNav();

    setTimeout(function() {
      focusTrapOne.activate();
    }, 300);

    containerOne.classList.add = 'trap is-active';
  });

  mobileClose.addEventListener('click', () => {
    toggleMobileNav();

    focusTrapOne.deactivate();
  });
}

window.addEventListener("vueloaded", () => {

  initMobileMenuListeners();

});
